var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"spinner",class:`${_vm.size} ${_vm.colorSchemeClasses}`})
}
var staticRenderFns = []

export { render, staticRenderFns }